import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@/hooks/useToast'
import { tasksApi } from '@/lib/api'

export function usePalletWork(taskUuid: string) {
  const { toast } = useToast()
  const qc = useQueryClient()

  const invalidate = () => {
    void qc.invalidateQueries({ queryKey: ['task-pallets', taskUuid] })
    void qc.invalidateQueries({ queryKey: ['task-boxes', taskUuid] })
    void qc.invalidateQueries({ queryKey: ['tasks'] })
    void qc.invalidateQueries({ queryKey: ['task', taskUuid] })
  }

  const take = useMutation({
    mutationFn: ({
      palletNum,
      workerName,
      production_date,
      expiry_date,
    }: {
      palletNum: number
      workerName: string
      production_date?: string
      expiry_date?: string
    }) => tasksApi.takePallet(taskUuid, palletNum, workerName, { production_date, expiry_date }),
    onSuccess: () => {
      toast.success('Паллета взята в работу')
      invalidate()
    },
  })

  const release = useMutation({
    mutationFn: ({ palletNum, workerName }: { palletNum: number; workerName: string }) =>
      tasksApi.releasePallet(taskUuid, palletNum, workerName),
    onSuccess: () => {
      toast.success('Паллета освобождена')
      invalidate()
    },
  })

  return {
    takePallet: take.mutateAsync,
    releasePallet: release.mutateAsync,
    isTaking: take.isPending,
    isReleasing: release.isPending,
  }
}
